import { Button } from '@egw/components'
import { useTranslation } from '@egw/i18n'
import { EnrollmentHYCSLayout } from '@egw/layouts'
import { type FC } from 'react'
import { useNavigate } from 'react-router'
import { WEALTH_ROUTES } from '@egw/constants'
import { PageHeader } from '../../../components'

export const TechnicalIssuesPage: FC = () => {
  const { t } = useTranslation('features-enrollment')
  const navigate = useNavigate()

  const onSubmit = (): void => {
    void navigate(WEALTH_ROUTES.ENROLLMENT.path)
  }

  return (
    <EnrollmentHYCSLayout title={t('generic.technical_difficulties.page_title')}>
      <div className="egw-container-enroll-hycs h-full flex flex-col relative md:justify-center justify-start items-start">
        <PageHeader title={t('generic.technical_difficulties.title')} />
        <div className="flex flex-col gap-md">
          <p className="typo-primary-base text-text-body">{t('generic.technical_difficulties.description_1')}</p>
          <p className="typo-primary-base text-text-body">{t('generic.technical_difficulties.description_2')}</p>
        </div>
        <div className="flex-1 md:hidden" />

        <Button type="button" className="w-full md:w-min mt-xl" onClick={onSubmit} testId="primaryAction_button">
          {t('generic.technical_difficulties.cta')}
        </Button>
      </div>
    </EnrollmentHYCSLayout>
  )
}
